<template>
  <div>
    <v-card>
      <v-card-title>
        Baja de Mercaderias
        <v-spacer></v-spacer>
        <v-btn class="ma-2" color="red" fab small dark @click="_cerrar()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-stepper v-model="stepper" vertical>
          <v-stepper-step :complete="stepper > 1" step="1">
            Motivo
            <small>Seleccione el motivo de la baja de mercaderias</small>
          </v-stepper-step>
          <v-stepper-content step="1">
            <v-select
              v-model="formulario.motivo"
              :items="motivos"
              menu-props="auto"
              label="Seleccione motivo"
              hide-details
              single-line
              class="mb-2"
            ></v-select>
            <v-btn color="primary" @click="paso(1)" :disabled="formulario.motivo === ''">Continuar</v-btn>
          </v-stepper-content>
          <v-stepper-step :complete="stepper > 2" step="2">
            Mercaderias
            <small>Seleccione las mercaderias a dar de baja</small>
          </v-stepper-step>
          <v-stepper-content step="2">
            <v-skeleton-loader v-if="loadingProductos" type="table"></v-skeleton-loader>

            <div v-else>
              <v-row>
                <v-col cols="8">
                  <v-text-field
                    v-model="buscadorProductos"
                    append-icon="mdi-magnify"
                    label="Buscar producto"
                    single-line
                    hide-details
                  ></v-text-field>
                  <v-data-table
                    :headers="encProductos"
                    :search="buscadorProductos"
                    :items="productos"
                    class="elevation-1"
                    @click:row="agregarProducto"
                  ></v-data-table>
                </v-col>

                <v-col cols="4">
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">Producto</th>
                          <th class="text-left">Cantidad</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in formulario.productos" :key="item.producto">
                          <td>{{ item.nombre }}</td>
                          <td>{{ item.cantidad }}</td>
                          <td>
                            <v-icon small class="mr-2" @click="editarProducto(item)">mdi-pencil</v-icon>
                            <v-icon small class="mr-2" @click="borrarProducto(item)">mdi-delete</v-icon>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <span v-if="formulario.productos.length === 0">Debe ingresar al menos un producto.</span>
                </v-col>
              </v-row>
            </div>
            <div class="mt-2">
              <v-btn
                color="primary"
                @click="paso(2)"
                :disabled="formulario.productos.length === 0"
              >Continuar</v-btn>
              <v-btn text @click="stepper = 1">Anterior</v-btn>
            </div>
          </v-stepper-content>
          <v-stepper-step :complete="stepper > 3" step="3">Detalles</v-stepper-step>
          <v-stepper-content step="3">
            <v-autocomplete
              v-if="formulario.motivo === 'intersucursal'"
              v-model="formulario.detalles.sucursal"
              :items="sucursales"
              :loading="loadingSucursales"
              item-text="descripcion"
              item-value="_id"
              hide-no-data
              label="Sucursal de Destino"
            ></v-autocomplete>
            <v-textarea outlined v-model="formulario.detalles.observacion" label="Observacion"></v-textarea>
            <div>
              <v-btn color="primary" @click="guardarBaja()" :loading="loadingFormulario">
                <v-icon>mdi-check</v-icon>Guardar Baja
              </v-btn>
              <v-btn text @click="stepper = 2">Anterior</v-btn>
            </div>
          </v-stepper-content>
        </v-stepper>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Mercaderias_Baja",
  data() {
    return {
      stepper: 1,
      motivos: [{ text: "Movimiento intersucursal", value: "intersucursal" },
      { text: "Mercaderia dañada", value: "mercaderia dañada" }],
      sucursales: [],
      formulario: {
        motivo: "",
        productos: [],
        detalles: {
          sucursal: "",
          observacion: ""
        }
      },
      productos: [],
      encProductos: [
        {
          text: "Codigo",
          align: "start",
          value: "codigo"
        },
        { text: "Nombre", value: "nombre" },
        { text: "Categoria", value: "categoria" },
        { text: "Stock", value: "stock" }
      ],
      buscadorProductos: "",
      loadingProductos: true,
      loadingSucursales: true,
      loadingFormulario: false
    };
  },
  methods: {
    paso(step) {
      switch (step) {
        case 1:
          if (this.formulario.motivo != "") this.stepper = 2;
          break;
        case 2:
          if (this.formulario.productos.length > 0) {
            this.stepper = 3;
            if (this.formulario.motivo === "intersucursal") {
              this.cargarSucursales();
            }
          }
          break;
      }
    },
    async cargarSucursales() {
      try {
        const sucursales = await axios.get("/sucursales");
        this.sucursales = sucursales.data;
        let find = this.sucursales.find(
          el => el._id === $cookies.get("datos").sucursal._id
        );
        let i = this.sucursales.indexOf(find);
        this.sucursales.splice(i, 1);
        this.loadingSucursales = false;
      } catch (error) {
        console.log(error);
      }
    },
    agregarProducto(item) {
      let cantidad = prompt("Ingrese cantidad de " + item.nombre, "");
      if (cantidad) {
        cantidad = parseFloat(cantidad);
        if (item.stock < cantidad) {
          alert("Stock insuficiente.");
        } else {
          if (!isNaN(cantidad) && cantidad > 0 && item.stock) {
            let producto = {
              producto: item._id,
              nombre: item.nombre,
              stock: item.stock,
              cantidad
            };
            const found = this.formulario.productos.find(
              el => el.producto === producto.producto
            );
            if (found) {
              let index = this.formulario.productos.indexOf(found);
              this.formulario.productos[index].cantidad += producto.cantidad;
            } else {
              this.formulario.productos.push(producto);
            }
          } else {
            alert("Debe ingresar una cantidad mayor a cero.");
          }
        }
      }
    },
    editarProducto(item) {
      let cantidad = prompt(
        "Ingrese cantidad de " + item.nombre,
        item.cantidad
      );
      if (cantidad) {
        cantidad = parseFloat(cantidad);
        if (item.stock < cantidad) {
          alert("Stock insuficiente.");
        } else {
          if (!isNaN(cantidad) && cantidad > 0) {
            let index = this.formulario.productos.indexOf(item);
            this.formulario.productos[index].cantidad = cantidad;
          } else {
            alert("Debe ingresar una cantidad mayor a cero.");
          }
        }
      }
    },
    borrarProducto(item) {
      if (confirm("¿Quitar el producto " + item.nombre + "?")) {
        let index = this.formulario.productos.indexOf(item);
        this.formulario.productos.splice(index, 1);
      }
    },
    async guardarBaja() {
      this.loadingFormulario = true;
      try {
        if (
          this.formulario.motivo === "intersucursal" &&
          this.formulario.detalles.sucursal === ""
        )
          throw "Debe seleccionar una Sucursal de Destino.";
        const baja = await axios.post("/mercaderia/baja", this.formulario);
        this.$router.push(`/mercaderias/baja/${baja.data}`);
      } catch (error) {
        alert(error);
      }
      this.loadingFormulario = false;
    },
    _cerrar() {
      if (confirm("¿Cancelar operación actual?")) {
        this.$router.push(`/mercaderias`);
      }
    }
  },
  async created() {
    try {
      const productos = await axios.get("/productos");
      this.productos = productos.data;
      this.loadingProductos = false;
    } catch (error) {
      console.log(error);
    }
  }
};
</script>